"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _PreviewLoader = _interopRequireDefault(require("./PreviewLoader"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _jsxFileName = "/Users/newuser/Documents/GitHub/gatsby-plugin-wordsby/src/components/Preview/index.js";
var robot = false;
var postRobot;

if (typeof window !== "undefined") {
  postRobot = require("post-robot");
} else {
  postRobot = false;
}

var Preview =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Preview, _Component);

  function Preview(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPreviewDataFromPostRobot", function () {
      postRobot.on("previewDataLoaded", function (event) {
        var previewData = event.data.previewData;

        _this.setState({
          previewData: previewData
        });

        return {
          previewDataLoaded: true
        };
      });
      setTimeout(function () {
        return postRobot.send(window.parent, "iframeReadyForData", {
          iframeReady: true
        });
      }, 1000);
      return;
    });
    _this.state = {
      previewData: false,
      error: false
    };
    _this.getPreviewDataFromPostRobot = _this.getPreviewDataFromPostRobot.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

    if (!!postRobot && robot.cancel) {
      robot.cancel();
    }

    return _this;
  }

  var _proto = Preview.prototype;

  _proto.inIframe = function inIframe() {
    if (typeof window === "undefined") return false;

    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.inIframe()) {
      return this.getPreviewDataFromPostRobot();
    }

    var urlParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : false;
    if (!urlParams) return;
    var rest_base = urlParams.get("rest_base");
    var post_id = urlParams.get("preview");
    var nonce = urlParams.get("nonce");

    if ((!rest_base || !post_id || !nonce) && !this.inIframe()) {
      // redirect home if a preview page is accessed directly
      window.location.href = "/";
    }

    console.log("preview props", this.props);
    var _this$props$pageConte = this.props.pageContext,
        siteUrl = _this$props$pageConte.siteUrl,
        env = _this$props$pageConte.env;
    console.log("site url", siteUrl);
    console.log("env", env);
    var rest_url = siteUrl + "/wp-json/wp/v2/" + rest_base + "/" + post_id + "/preview/" + (env !== "development" ? "?_wpnonce=" + nonce : "");
    console.log("rest_url", rest_url);
    fetch(rest_url).then(function (res) {
      console.log("response", res);
      return res.json();
    }).then(function (res) {
      console.log("json response", res);

      if (res && res.ID) {
        console.log("Updating preview data");

        _this2.setState({
          previewData: res
        });
      } else if (res && res.code) {
        _this2.setState({
          error: {
            title: "Oh no! <br> There's been an error :(",
            message: "To fix: <br>\n                        Close this page, log out of WordPress, log back in, and try again.<br>\n                        If the issue persists, copy this message and send it to your web developer.",
            error: res
          }
        });
      } else {
        _this2.setState({
          error: {
            title: "Dang,",
            message: "<h3>looks like something went wrong!</h3><br> There was no response from the server. <br>Contact your web developer for help."
          }
        });
      }
    }).catch(function (error) {
      return console.warn(error);
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        children = _this$props.children,
        _this$props$data = _this$props.data,
        wordpressWpCollections = _this$props$data.wordpressWpCollections,
        wordsbyCollections = _this$props$data.wordsbyCollections,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props$data, ["wordpressWpCollections", "wordsbyCollections"]);

    if (this.state.previewData && typeof window !== "undefined") {
      var childrenWithPreview = _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          data: (0, _extends2.default)({
            wordsbyCollections: _this3.state.previewData
          }, rest),
          previewData: (0, _extends2.default)({
            wordsbyCollections: _this3.state.previewData
          }, rest)
        });
      });

      return childrenWithPreview;
    } else {
      return _react.default.createElement(_PreviewLoader.default, {
        error: this.state.error,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151
        },
        __self: this
      });
    }
  };

  return Preview;
}(_react.Component);

var PreviewContainer = function PreviewContainer(props) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactHelmet.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159
    },
    __self: this
  }, _react.default.createElement("meta", {
    name: "robots",
    content: "noindex",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160
    },
    __self: this
  })), _react.default.createElement(Preview, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162
    },
    __self: this
  })));
};

var _default = PreviewContainer;
exports.default = _default;